<template>
  <div>
    <og-simple-date-input
      v-model="formData.eventual_fecha_fin"
      :disabled="disabled"
      :label="$t('Fecha de fin')"
      required
    ></og-simple-date-input>
    <v-textarea
      v-model="formData.motivo_temporalidad"
      :disabled="disabled"
      :label="$t('Motivo de la temporalidad')"
      :rules="[rules.required]"
      required
      box
    ></v-textarea>
  </div>
</template>

<script>
import OgSimpleDateInput from '@/components/commons/form/inputs/OgSimpleDateInput.vue';

export default {
  components: { OgSimpleDateInput },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default() {
        return {
          eventual_fecha_fin: null,
          motivo_temporalidad: null,
        };
      },
    },
  },
  data() {
    return {
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
        counter: value => value.length <= 20 || 'Max 20 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Email inválido';
        },
      },
    };
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style lang="scss"></style>
